/**
 * 系统管理 菜单管理
 */
<template>
  <div class="main">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>导购知识</el-breadcrumb-item>
      <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
        <el-form class="user-search">
          <el-form-item>
            <el-button size="small" type="primary" @click="goback">返回</el-button>
          </el-form-item>
        </el-form>
        
        
		<el-form label-width="120px" ref="editForm" :model="formProInfo" class="editForm">
		  <el-form-item label="分类名称" prop="productName">
		    <el-input size="small" v-model="formProInfo.name" auto-complete="off" placeholder="请输入分类名称"></el-input>
		  </el-form-item>
		  
		  <el-form-item label="选择分类" v-if="shuo=='新增'">
		   <el-select size="small" v-model="formProInfo.level" placeholder="请选择" @change='changelevel'>
		      <el-option label="分类1" value="1"></el-option>
		      <el-option label="分类2" value="2"></el-option>
		      <el-option label="分类3" value="3"></el-option>
		    </el-select>
		  </el-form-item>
		  
		  <el-form-item label="所属导购">
		   <el-select size="small" v-model="formProInfo.category" placeholder="请选择" @change='changedao'>
		      <el-option label="导购知识视频" value="1"></el-option>
		      <el-option label="服务视频" value="2"></el-option>
		      <el-option label="导购文件" value="3"></el-option>
		    </el-select>
		  </el-form-item>
		  
		  <el-form-item label="所属分类1" v-if="formProInfo.level==2 || formProInfo.level==3">
		   <el-select size="small" v-model="formProInfo.firstLevelId" placeholder="请选择"  @change="changetype">
		      <el-option v-for="(item,index) in typeList1" :label="item.name" :value="item.id"></el-option>
		    </el-select>
		  </el-form-item>
		  
		  <el-form-item label="所属分类2" v-if="formProInfo.level==3">
		   <el-select size="small" v-model="formProInfo.secondLevelId" placeholder="请选择">
		       <el-option v-for="(item1,index1) in typeList2" :label="item1.name" :value="item1.id"></el-option>
		    </el-select>
		  </el-form-item>
		  
		  <el-form-item label="序号" prop="sortNumber">
		    <el-input size="small" v-model="formProInfo.sortNumber" auto-complete="off" placeholder="请输入序号,数字越小越靠前，整数"></el-input>
		  </el-form-item>
		  
		  <el-form-item label="状态" :prop="formProInfo.active">
		    <el-radio v-model="formProInfo.active" label="1">启用</el-radio>
		    <el-radio v-model="formProInfo.active" label="0">禁用</el-radio>
		  </el-form-item>
		 
		  
		</el-form>
		
		
		<div slot="footer" class="dialog-footer">
		  <el-button size="small" type="primary" :loading="loading" class="title" @click="saveProInfo">保存</el-button>
		</div>
		
		
		
		
		
		
      </div>
    </template>

    <script>
    // 导入请求方法
    import {
      createShoppyType,
	  getShoppyTypeList,
	  getShoppyTypeById,
	  updateShoppyType
      } from '../../api/knowledgeFun'
    import Pagination from '../../components/Pagination'

  
    import {evaluateUpload }from '@/api/auth';
    import { setCookie, getCookie, delCookie } from '../../utils/util'



    export default {
      data() {
        return {
          loading: false, //是显示加载
		  keytype:0,
          title: '导购分类新增',
          level:'',
		  typeList1:'',
		  typeList2:'',
          // 请求数据参数
          formProInfo: {
            // 分类名称(支持右模糊查询)
            name: '',
            //导购分类级别：1-一级分类(分类1)；2-二级分类(分类2)；3-三级分类(分类3)
            level: '',
            //所属导购：1-导购知识视频；2-服务视频；3-导购文件
            category:'',
            //分类状态：0-禁用；1-启用
            active:'1',
            updator:'',
			firstLevelId:'',
			secondLevelId:'',
			sortNumber:''
          },
    	  id:'',
		  shuo:''
         
         
        }
      },
      // 注册组件
      components: {
        Pagination
      },

      /**
       * 数据发生改变
       */
      watch: {},

      /**
       * 创建完毕
       */
      created() {
        //this.getData(this.formProInfo)

      },
      mounted(){
		  this.level = this.$route.query.level
		  this.id = this.$route.query.id
		  this.formProInfo.level = this.level
		  this.shuo = this.$route.query.shuo
		 
		  if(this.shuo=='新增'){
			  this.title = '知识导购分类' + this.level +'新增'
		  }else{
			  this.title = '知识导购分类' + this.level +'编辑'
			  this.handleEdit()
		  }
        // document.addEventListener("paste", this.handlePaste);
      },
      beforeDestroy(){
        // document.removeEventListener("paste",this.handlePaste);
      },
      /**
       * 里面的方法只有被调用才会执行
       */
      methods: {
		//编辑
		goback() {
			this.$router.push({ path: '/product4?level='+this.formProInfo.level})
		 
		},
		changelevel(e){
			if(this.shuo=='新增'){
				this.level = e
				 this.title = '知识导购分类' + this.level +'新增'
			}else{
				this.title = '知识导购分类' + this.level +'编辑'
			}
		},
      changedao(e){
		  console.log(12345,e)
		 // this.formProInfo.category = e
		 let parm = {
			 level:1,
			 category:this.formProInfo.category,
			 firstLevelId:'',
			 secondLevelId:this.formProInfo.secondLevelId
			 
		 }
		  getShoppyTypeList(parm).then(res => {
		    console.log(123)
		    this.loading = false
		    if (res.success == false) {
		      this.$message({
		        type: 'info',
		        message: res.msg
		      })
		    } else {
		    this.typeList1 = res.data
			
		    }
		  })
	  },
	  changetype(e){
		  this.keytype = this.keytype + 1
		  console.log(123456,e)
		  //this.formProInfo.firstLevelId = e
		  let parm = {
				 level:2,
				 category:this.formProInfo.category,
				 firstLevelId:this.formProInfo.firstLevelId,
				 secondLevelId:''
		  			 
		  }
		  getShoppyTypeList(parm).then(res => {
			console.log(123)
			this.loading = false
			if (res.success == false) {
			  this.$message({
				type: 'info',
				message: res.msg
			  })
			} else {
			this.typeList2 = res.data
			
			}
		  })
	  },
        //搜索事件
        search() {
          console.log(123)
          console.log(this.dateValue)
          this.formProInfo.pageIndex = 1
          this.getData(this.formProInfo)
        },


        
        //显示编辑界面
        handleEdit: function() {
            getShoppyTypeById(this.id).then(res => {
                this.loading = false
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg+'TraceId:'+res.traceId
                  })
                } else {
                  console.log(999999999,res)
				this.formProInfo.active = String(res.data.active)
				this.formProInfo.category = String(res.data.category)
                this.formProInfo.name = res.data.name
				this.formProInfo.firstLevelId = res.data.firstLevelId
				this.formProInfo.sortNumber = res.data.sortNumber
				if(this.level == 2){
					this.changedao()
				}
				if(this.level == 3){
					this.changedao()
					this.changetype()
					this.formProInfo.secondLevelId = res.data.secondLevelId
				}
				
				
                }
              })

         
        },
        // 编辑、添加提交方法
        saveProInfo(){
            console.log(this.content)
             if(!this.formProInfo.name){
              return this.$message({
                      type: 'warning',
                      message: '请填写分类名称'
                    })
            }
			if(!this.formProInfo.name.length>8){
			  return this.$message({
			          type: 'warning',
			          message: '请填写小于8位的分类名称！'
			        })
			}
			if(!this.formProInfo.level){
			  return this.$message({
			          type: 'warning',
			          message: '请选择导购分类级别！'
			        })
			}
			if(!this.formProInfo.category){
			  return this.$message({
			          type: 'warning',
			          message: '请选择所属导购！'
			        })
			}
			this.formProInfo.sortNumber = Number(this.formProInfo.sortNumber)
			let sortNumbertype = Number.isInteger(this.formProInfo.sortNumber)
			if(sortNumbertype==false){
			  return this.$message({
			          type: 'warning',
			          message: '请填写整数！'
			        })
			}
			if(this.formProInfo.sortNumber==''){
				this.formProInfo.sortNumber=null
			}
            if(this.shuo=='新增'){
				createShoppyType(this.formProInfo).then(res => {
				  console.log(123)
				  this.loading = false
				  if (res.success == false) {
				    this.$message({
				      type: 'info',
				      message: res.msg
				    })
				  } else {
				   this.$message({
				     type: 'success',
				     message: '保存成功'
				   })
				  }
				})
			}else{
				this.formProInfo.id = this.id
				updateShoppyType(this.formProInfo).then(res => {
				  console.log(123)
				  this.loading = false
				  if (res.success == false) {
				    this.$message({
				      type: 'info',
				      message: res.msg
				    })
				  } else {
				   this.$message({
				     type: 'success',
				     message: '保存成功'
				   })
				  }
				})
			}
          
    		
        },

       

        // 选择复选框事件
        selectChange(val) {
          this.selectdata = val
        },
       
        

      }
    }
    </script>

    <style scoped>
    .user-search {
		position: absolute;
		top: 20px;
		right: 0px;
		width: 100px;
    }
    .userRole {
      width: 100%;
    }
    .main{
    	background-color: #fff;
    	padding: 30px;
    	border-radius: 10px;
    }
    /* .avatar-uploader{
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
    } */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  
  .editForm{
	  margin: 0 auto;
	  margin-top: 30px;
	  width: 400px;
	  
  }
  .el-select{
	  width: 100%;
  }
  .dialog-footer{
	  margin: 0 auto;
	  margin-top: 30px;
	  width: 280px;
	  padding-left: 120px;
  }
  .title{
	  width: 100%;
  }
    </style>





// WEBPACK FOOTER //
// src/views/knowledge/productadd4.vue